import $ from 'jquery'
import 'slick-carousel'

export default (slider) => {
  const hideDots = function ($slides, $dots) {
    const length = window.innerWidth <= 1024 ? 1 : 4
    if ($slides.length <= length) {
      $dots.hide()
    }
  }


  const centerMode = slider.querySelector('.additional-images').childElementCount <= 1

  $('.additional-images', slider).slick({
    rows: 0,
    lazyLoad:'progressive',
    arrows: false,
    dots: true,
    infinite: false,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    touchThreshold: 15,
    variableWidth: true,
    swipeToSlide: true,
    centerMode: centerMode,
    speed: 300,
    centerPadding: '10px',
    accessibility: false,
    customPaging : function(slider, i) {
      return '<svg version="1.0" xmlns="http://www.w3.org/2000/svg"\n' +
        ' width="16.000000pt" height="16.000000pt" viewBox="0 0 16.000000 16.000000"\n' +
        ' preserveAspectRatio="xMidYMid meet">\n' +
        '\n' +
        '<g transform="translate(0.000000,16.000000) scale(0.100000,-0.100000)"\n' +
        'stroke="none">\n' +
        '<path d="M25 135 c-40 -39 -32 -96 16 -120 40 -21 66 -19 94 10 50 49 15 135\n' +
        '-55 135 -19 0 -40 -9 -55 -25z m95 -15 c28 -28 26 -66 -6 -86 -55 -37 -117 25\n' +
        '-80 80 20 32 58 34 86 6z"/>\n' +
        '<path class="dot" d="M57 103 c-14 -13 -7 -43 12 -53 28 -14 55 13 41 41 -10 19 -40 26\n' +
        '-53 12z"/>\n' +
        '</g>\n' +
        '</svg>';
    },
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          lazyLoad:'ondemand',
          swipeToSlide: false,
          slidesToShow: 4,
          slidesToScroll: 4,
          centerMode: centerMode,
          centerPadding: '0',
        },
      }
    ],
  }).on('breakpoint', function () {
    hideDots($(this).find('.slick-slide'), $(this).find('.slick-dots'))
  })
  hideDots($('.slick-slide', slider), $('.slick-dots', slider))
}
